import {Palette} from "@Styles/Palette.style";

export const passengerClassGroupsBackgroundColoring = [
    Palette.mangolia,
    Palette.mintCream,
    Palette.aliceBlue,
    Palette.cosmicLatte,
    Palette.lavenderBlush,
    Palette.mauve,
    Palette.mintGreen,
    Palette.lavander,
    Palette.peach,
    Palette.teaRoseRed,
]